var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.824269,
    y: 0.871465,
    width: 53.3137,
    height: 53.3137,
    rx: 26.6568,
    fill: "#F9F9F9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.824269,
    y: 0.871465,
    width: 53.3137,
    height: 53.3137,
    rx: 26.6568,
    stroke: "#EAEBF0",
    strokeWidth: 0.96934
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.444 27.1295L35.952 23.8841C36.3654 23.5017 37.0306 23.681 37.1469 24.232C37.7468 27.073 37.4291 30.1971 37.0489 32.3451C36.756 34.0004 35.4314 35.2401 33.7702 35.4974C29.5296 36.1547 25.4327 36.1547 21.1921 35.4976C19.5309 35.2402 18.2062 34.0005 17.9132 32.3451C17.5331 30.1973 17.2153 27.0732 17.8152 24.2323C17.9316 23.6812 18.5968 23.5019 19.0102 23.8844L22.5177 27.1292C23.4751 23.983 25.2174 21.1705 26.5176 19.5421C27.0242 18.9076 27.9373 18.9076 28.4439 19.5421C29.7442 21.1705 31.4865 23.9832 32.444 27.1295Z",
    stroke: "black",
    strokeWidth: 1.44982,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopCategory);
export default __webpack_public_path__ + "static/media/top_category.425ed74112feff2ffeda1aeaabaad560.svg";
export { ForwardRef as ReactComponent };